import { TableNode } from "../models/TableNode";

export namespace TableUtilsGeneral {

    export function getParentsDataArray<TData>(node: TableNode<TData>): TData[] {
        const parents: TData[] = [];
        if (!node) return parents;
        let current: TableNode<TData> | null = node.itemParent;
        while (current) {
            parents.push(current.data);
            current = current.itemParent;
        }
        return parents;
    }

    export function getParentsNodeArray<TData>(node: TableNode<TData>): TableNode<TData>[] {
        const parents: TableNode<TData>[] = [];
        if (!node) return parents;
        let current: TableNode<TData> | null = node.itemParent;
        while (current) {
            parents.push(current);
            current = current.itemParent;
        }
        return parents;
    }
}